import React from 'react';
import Chip from '@material-ui/core/Chip';
import { Status } from '../../../services/exams/assessmentSession/assessments.types';
interface ChipProps {
  value: Status | null;
}

export const ChipButton: React.FC<ChipProps> = (props) => {
  switch (props.value) {
    case Status.Open:
      return (
        <Chip
          style={{
            color: '#3560FF',
            justifyContent: 'center',
            borderColor: '#3560FF',
            marginLeft: '10px',
          }}
          label="Otwarte"
          variant="outlined"
          size="small"
        />
      );
    case Status.New:
      return (
        <Chip
          style={{
            color: '#9747FF',
            borderColor: '#9747FF',
            justifyContent: 'center',
          }}
          label="Nowe"
          variant="outlined"
          size="small"
        />
      );
    case Status.Assessed:
      return (
        <Chip
          style={{
            color: '#347F42',
            borderColor: '#347F42',
            justifyContent: 'center',
          }}
          label="Ocenione"
          variant="outlined"
          size="small"
        />
      );
    case Status.Closed:
      return (
        <Chip
          style={{
            color: '#EA2075',
            borderColor: '#EA2075',
            justifyContent: 'center',
          }}
          label="Zamknięte"
          variant="outlined"
          size="small"
        />
      );
    default:
      return <></>;
  }
};
